import React, { useState } from "react";
import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface SearchBarProps {
  onSearch?: (query: string) => void;
  className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch, className }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      if (onSearch) {
        onSearch(searchQuery.trim());
      } else {
        navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
      }
      setSearchQuery("");
    }
  };

  return (
    <form
      onSubmit={handleSearch}
      className={`flex items-center space-x-2 ${className}`}
    >
      <input
        type="search"
        placeholder="Search products..."
        className="flex w-full px-4 py-2 border border-gray-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-primary-darker-green focus:border-transparent"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <button
        type="submit"
        className="px-6 py-2 bg-primary-darker-green text-white rounded-2xl hover:bg-opacity-90 transition-colors duration-200"
      >
        <Search className="w-5 h-6" />
      </button>
    </form>
  );
};

export default SearchBar;
